import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isVisible, setIsVisible] = useState(false);

  const onClickButton = () => {
    setIsVisible(isVisible ? false : true);
  };
  return (
    <header class="bg-gray-800 p-2 sticky top-0 z-50">
      <div class="max-w-6xl mx-auto flex justify-between items-center h-12">
        <Link to="/#main" class="h-full w-1/4 img1">
          {/* <div class="h-full w-1/4 img1"></div> */}
        </Link>
        <nav>
          <ul class="hidden md:flex space-x-6">
            <li>
              <Link to="/#o-mnie" class="hover:text-gray-300">
                O mnie
              </Link>
            </li>
            <li>
              <Link to="/#oferta" class="hover:text-gray-300">
                Oferta
              </Link>
            </li>
            <li>
              <Link to="/#opinie" class="hover:text-gray-300">
                Opinie
              </Link>
            </li>
            <li>
              <Link to="/#kontakt" class="hover:text-gray-300">
                Kontakt
              </Link>
            </li>
          </ul>
          <div class="md:hidden">
            <button
              id="menuBtn"
              onClick={onClickButton}
              class="text-white focus:outline-none text-2xl"
            >
              <i class="ph ph-list"></i>
            </button>
          </div>
        </nav>
      </div>
      <div id="mobileMenu" class={`md:hidden ${isVisible ? '' : 'hidden'} p-4`}>
        <Link to="/#o-mnie" class="block py-1" onClick={onClickButton}>
          O mnie
        </Link>
        <Link to="/#oferta" class="block py-1" onClick={onClickButton}>
          Oferta + Cennik
        </Link>
        <Link to="/#opinie" class="block py-1" onClick={onClickButton}>
          Opinie
        </Link>
        <Link to="/#kontakt" class="block py-1" onClick={onClickButton}>
          Kontakt
        </Link>
      </div>
    </header>
  );
};

export default Header;
